import React from 'react';
import './Sermons.css';
import pastor from '../Images/pastor.jpg';

const todaySermon = [
    {
        title : "Repentance",
        date : "7/3/2020",
        image: "https://thumbs.dreamstime.com/b/open-bible-black-background-70567202.jpg",
        preacher: " Daniel Muoki",
        contacts: " +254 712345678",
        reading: "Ephesians 6 : 1-10",
        description : " This will teach us the love that God gave to the earth"
    },

    {
        title : "second coming",
        date : "28/2/2020",
        image: "https://media.swncdn.com/cms/CW/faith/31507-biblewithlight-light-bible.1200w.tn.jpg",
        preacher: " John Mutisya",
        contacts: " +254 712345678",
        reading: "Ephesians 6 : 1-10",
        description : " This will teach us the love that God gave to the earth"
    },

    {
        title : "Love & forgiveness",
        date : "21/2/2020",
        image: `${pastor}`,
        preacher: " 'Name'",
        contacts: " +254 712345678",
        reading: "Ephesians 6 : 1-10",
        description : " This will teach us the love that God gave to the earth"
    },
    {
        title : "Fruits of holy spirit",
        date : "14/2/2020",
        image: "https://www.cambridge.org/files/6615/7106/4611/Topazblue1.jpg",
        preacher: " Jonh Mutisya",
        contacts: " +254 712345678",
        reading: "Ephesians 6 : 1-10",
        description : " This will teach us the love that God gave to the earth"
    },
    {
        title : "Gifts of holy spirit",
        date : "7/2/2020",
        image: "https://www.cambridge.org/files/6615/7106/4611/Topazblue1.jpg",
        preacher: " Daniel Muoki",
        contacts: " +254 712345678",
        reading: "Ephesians 6 : 1-10",
        description : " This will teach us the love that God gave to the earth"
    }
]
function Sermons() {
    return (
        <div className="sermons">
            <div className="sermonsBody__header">
                <img src={pastor} alt=""/>
                <h3>Let us study the word of God</h3>
                <h3>Call all the nations together and praise the most high</h3>
            </div>
            <div className="sermonBody">
                <div className="sermonsBody__body">
                    {todaySermon.map((item, index) => (
                        <div key={index} className="todaySermon">
                            <h3>{item.title}</h3>
                            <div className="todaySermon-div">
                                <div className="pastor">
                                    <img src={item.image} alt= ""/>
                                    <h4>Pastor {item.preacher}</h4>
                                    <p>{item.contacts}</p>
                                </div>
                                <h4>{item.reading}</h4>
                                <p>{item.description}</p>
                                <div className="date">
                                    <p>{item.date}</p>
                                </div>
                            </div>
                            
                        </div>
                    ))}

                </div>
            </div>
        </div>
    )
}

export default Sermons
